import Head from 'next/head';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  pageTitle: {
    defaultMessage: 'Heidi | Your AI Care Partner for Modern Clinical Practice',
    id: 'wZZQWubcDx',
    description: 'Default HTML document title for the Heidi Scribe application',
  },
});

export const AppHead = () => {
  const intl = useIntl();
  const pageTitle = intl.formatMessage(messages.pageTitle);

  return (
    <Head>
      <title key="title">{pageTitle}</title>
      <meta
        key="description"
        name="description"
        content="Heidi is your AI care partner — an ambient AI medical scribe that automates clinical documentation so you can focus on patient care. Sign in or sign up free."
      />
      <meta charSet="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, interactive-widget=resizes-content"
      />
      <meta name="application-name" content="Heidi" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="Heidi" />
      <meta name="format-detection" content="telephone=no" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-tap-highlight" content="no" />
      <meta name="theme-color" content="#ffffff" />

      <link rel="apple-touch-icon" href="/rebrand-favicon/apple-touch-icon.png" />
      <link
        rel="apple-touch-icon"
        sizes="152x152"
        href="/rebrand-favicon/apple-touch-icon.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/rebrand-favicon/apple-touch-icon.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="167x167"
        href="/rebrand-favicon/apple-touch-icon.png"
      />

      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/rebrand-favicon/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/rebrand-favicon/favicon-16x16.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="192x192"
        href="/rebrand-favicon/android-chrome-192x192.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="512x512"
        href="/rebrand-favicon/android-chrome-512x512.png"
      />
      <link rel="manifest" href="/rebrand-favicon/site.webmanifest" />
      <link rel="shortcut icon" href="/rebrand-favicon/favicon.ico" />

      <meta name="twitter:card" content="summary" />
      <meta key="twitter:title" name="twitter:title" content={pageTitle} />
      <meta
        key="twitter:description"
        name="twitter:description"
        content="Heidi is your AI care partner — an ambient AI medical scribe that automates clinical documentation so you can focus on patient care."
      />
      <meta
        name="twitter:image"
        content="https://scribe.heidihealth.com/rebrand-favicon/android-chrome-512x512.png"
      />
      <meta property="og:type" content="website" />
      <meta key="og:title" property="og:title" content={pageTitle} />
      <meta
        key="og:description"
        property="og:description"
        content="Heidi is your AI care partner — an ambient AI medical scribe that automates clinical documentation so you can focus on patient care."
      />
      <meta property="og:site_name" content="Heidi" />
      <meta key="og:url" property="og:url" content="https://scribe.heidihealth.com" />
      <meta
        property="og:image"
        content="https://scribe.heidihealth.com/rebrand-favicon/android-chrome-512x512.png"
      />

      <link
        rel="apple-touch-startup-image"
        href="/assets/images/apple_splash.png"
        sizes="2048x2732"
      />
      <link
        rel="apple-touch-startup-image"
        href="/assets/images/apple_splash.png"
        sizes="1668x2224"
      />
      <link
        rel="apple-touch-startup-image"
        href="/assets/images/apple_splash.png"
        sizes="1536x2048"
      />
      <link
        rel="apple-touch-startup-image"
        href="/assets/images/apple_splash.png"
        sizes="1125x2436"
      />
      <link
        rel="apple-touch-startup-image"
        href="/assets/images/apple_splash.png"
        sizes="1242x2208"
      />
      <link
        rel="apple-touch-startup-image"
        href="/assets/images/apple_splash.png"
        sizes="750x1334"
      />
      <link
        rel="apple-touch-startup-image"
        href="/assets/images/apple_splash.png"
        sizes="640x1136"
      />
      <meta
        name="apple-itunes-app"
        content="app-id=6504471106, app-argument=https://app.getheidi.com"
      />
    </Head>
  );
};
